<h3 class="book-title">{{ bookName }}</h3>
<div class="book-pages">
  @for (page of bookpages; track page) {
    <div
      class="page"
      (dblclick)="onBookpageDoubleClicked(page)"
      (click)="onBookpageClicked(page)"
      [ngClass]="getClass(page)"
      >
      <div class="image-wrapper">
        <img [src]="page.thumb" [pcpCrossoriginImage]="page.thumb" />
      </div>
      <div class="page-number">
        {{ 'bookpage.page-label' | transloco }}&nbsp;{{ page.page }}
      </div>
    </div>
  }
</div>
